export default "__VITE_ASSET__f602fab1__"